import { BaseModel } from './BaseModel';
import { RunTask } from './RunTask';

export class ScheduleRun extends BaseModel {
    public id = '';
    public status = '';
    public trigger = '';
    public message?: string;
    public messageParams: Record<string, unknown> = {};
    public startedAt?: string;
    public finishedAt?: string;
    public createdAt = '';
    public updatedAt = '';

    get tasks(): RunTask[] {
        return this.getRelationship('tasks');
    }
}
